import React,{useState} from 'react';
import ExpenseForm from './ExpenseForm';
import './NewExpense.css';
const NewExpense=(props)=>{
     const[isEditing ,setIsEditing]=useState(false);
   
    const saveExpenseDataHandler=(enteredExpenseData)=>{  //object aagya yaha as a parameter aagya ab
      const expenseData={   //new object banaya h ye aur user ne jo enter kiatha usko copy kardia aur id apne aap se daaldi
      ...enteredExpenseData,
      id:Math.random().toString()
    };
       props.onAddExpense(expenseData);  // updated object ko ab iske baap ke paas pochana h matlab App.js ke paas
         setIsEditing(false) ;                               // to fir se same concept lagaya h yha bhi..
  };
const startEditingHandler = () => { 
setIsEditing(true);
};

const stopEditingHandler = () => {
setIsEditing(false);

};



 return  (<div className="new-expense">
 { !isEditing && <button onClick={startEditingHandler}>Add New Expense</button>}
  
            {isEditing && <ExpenseForm onSaveExpenseData={saveExpenseDataHandler} onCancel={stopEditingHandler}> </ExpenseForm>   }
                                                                                       
         </div> );             //child function se jo updated object hai vo yha pe receive hoga
                             //aur voi object ab saveExpenseDataHandler vale function me as a parameter pass ho jaega
                             //isEditing variable ki value agar false hogi to form display nhi hoga sirf button show hoga
}                            //isEditing variable ki value agar true hogi to form display hoga button nhi show hoga
export default NewExpense;



